<template>
    <footer id="footer" class="footer">
        <div class="inner">
            <div class="fLogo">
                <img src="images/footer-logo.png" alt="Footer Logo" />
            </div>
            <div class="copyright" style="font-family: 'Noto Sans'">
                Copyright © {{ currentYear }} <span class="nowYear"></span> KOG Co, Ltd. All rights reserved
            </div>
        </div>
    </footer>
</template>

<script>
    export default  {
        computed: {
            currentYear() {
                return new Date().getFullYear()
            }
        }
    }
</script>

<style lang="scss">

    #footer {
        padding: 30px 0;
        text-align: center;
        background: #000;
    }

    #footer .fLogo img {
        width: 110px;
        height: auto;
    }

    #footer .copyright {
        color: #6c757d;
        margin-top: 20px;
        margin-bottom: 0;
    }

    #footer .privacy {
        display: flex;
        align-items: center;
        position: relative;
    }

    #footer .privacy::after {
        display: block;
        clear: both;
        content: '';
        width: 2px;
        height: 80%;
        background: #6c757d;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    #footer .privacy a {
        width: 50%;
        color: #6c757d;
        font-size: 22px;
        text-decoration: underline;
        transition: all 0.4s;
    }

    #footer .privacy a:first-child {
        text-align: right;
        margin-right: 30px;
    }

    #footer .privacy a:nth-child(2) {
        text-align: left;
    }

    #footer .privacy a:hover {
        color: #f1f1f1;
    }

    @media all and (max-width: 640px) {
        #footer .copyright {
            font-size: 12px;
        }
    }

</style>